module.exports = __webpack_public_path__ + "static/csa-logo-en-a257d42294f0219cda6f2c21d627b3ef.jpg";